export enum ExaExceptionCode {
  SERVICE_AUTHENTICATION_USER_NOT_VERIFIED = 3002,
  ACCESS_UNAUTHORIZED = 401,
  ACCESS_FORBIDDEN = 403,
  SERVICE_AUTHENTICATION_ANOTHER_USER_LOGGED_IN_WITH_SAME_ACCOUNT = 3004,
}
